const PAYMENT_COMPLETE = 'PAYMENT_COMPLET';
export const PRESCRIPTION = `${PAYMENT_COMPLETE}_PRESCRIPTION`;
export const TREATMENT_HISTORY_DETAIL = `${PAYMENT_COMPLETE}_TREATMENT_HISTORY_DETAIL`;
export const HOME = `${PAYMENT_COMPLETE}_HOME`;
